import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

export const EnablePointerEvents = createAction('[Tickets: Ticket Resolve]: Enable Pointer Events');

export const DisablePointerEvents = createAction(
  '[Tickets: Ticket Resolve]: Disable Pointer Events',
);

export const DropZoneEnabled = createAction('[Tickets: Ticket Resolve]: Drop Zone Enabled');

export const DropZoneDisabled = createAction('[Tickets: Ticket Resolve]: Drop Zone Disabled');

export const FileToUploadChanged = createAction(
  '[Tickets: Ticket Resolve]: File To Upload Changed',
  props<{ file: any }>(),
);

export const NotificationEmailChanged = createAction(
  '[Tickets: Ticket Resolve]: Notification Email Changed',
  props<{ notificationEmail: string }>(),
);

export const Resolve = createAction('[Tickets: Ticket Resolve]: Resolve');

export const ResolveSuccess = createAction(
  '[Tickets: Ticket Resolve]: Resolve Success',
  props<{ res: any }>(),
);

export const ResolveFailed = createAction(
  '[Tickets: Ticket Resolve]: Resolve Failed',
  props<{ error: HttpErrorResponse }>(),
);
